import { Component, OnInit, signal, computed } from '@angular/core';
import { Store } from '@ngrx/store';
import { State } from '../../../../core/store';
import { BaseComponent } from '../../../../core/abstracts/baseComponent';
import { Actions, ofType } from '@ngrx/effects';
import { Router } from '@angular/router';
import { SurveyModel, SurveyReportModel } from '../../../../models/surveyModel';
import { loadMyUnansweredSurvey, loadSurveyReport } from '../../../../core/store/survey/survey.actions';

@Component({
    selector: 'app-survey-report',
    templateUrl: './survey-report.component.html',
    styleUrls: ['./survey-report.component.scss'],
    standalone: false
})
export class SurveyReportComponent extends BaseComponent implements OnInit {

  surveyReport: SurveyReportModel[];
  loadingSurveyReport = false;
  dateRange;
  startingDateRange = [
    new Date(new Date().setMonth(new Date().getMonth() - 1)),
    new Date(),
  ];
  minTier: number;
  midTier: number;
  maxTier: number;
  
  totalRecords = signal<number>(0);
  dropdownOptions = computed(() => {
    var total = this.totalRecords();
    return [
      { label: '20', value: 20 },
      { label: '50', value: 50 },
      { label: '100', value: 100 },
      { label: '200', value: 200 },
      { label: '500', value: 500 },
      { label: 'All', value: total > 0 ? total : 20 } 
    ];
  });

  constructor(
    private actions$: Actions,
    private router: Router,
    private store: Store<State>) {
    super();
  }

  ngOnInit() {
    this.subs.push(
      this.store.select(s => s.surveyState.surveyReport).subscribe(surveyReport => {
        this.surveyReport = surveyReport;
        if(this.surveyReport != null)
          this.totalRecords.set(surveyReport.length)
      }),
      this.store.select(s => s.surveyState.loadingSurveyReport).subscribe(loadingSurveyReport => {
        this.loadingSurveyReport = loadingSurveyReport;
      }),
    );
    this.dateRange = this.startingDateRange;
    this.store.dispatch(loadSurveyReport({ filter: { dateRange: this.startingDateRange } }));

  }

  changedFilter() {
    if (this.dateRange && this.dateRange[0] && this.dateRange[1]) {
      this.store.dispatch(loadSurveyReport({ filter: { dateRange: this.dateRange } }));
    }
  }


  getTier(average: number) {
    if (this.minTier && this.midTier && this.maxTier) {
      if (average < this.minTier) {
        return '-';
      } else if (average < this.midTier) {
        return 'Min';
      } else if (average < this.maxTier) {
        return 'Mid';
      } else {
        return 'Max';
      }
    }
    return '-';
  }

  loadDetail(survey: SurveyReportModel) {
    this.router.navigate(['/survey/report/detail/' + survey.surveyTypeID + '/' + survey.mentorUserID]);
  }
}

